import { userApi } from './api'
import { DataHookOptions, useDataRead } from '@hooks/data'
import { User } from 'types/model'

function getPath(append?: string) {
  return append ? userApi.pathPrefix.concat(append) : userApi.pathPrefix
}

export function useUser(user?: string, options?: DataHookOptions<User>) {
  const path = user ? getPath(`/${user}`) : null
  return useDataRead<User>(userApi, path, options)
}

export function useMe(options?: DataHookOptions<User>) {
  return useUser('me', options)
}
